import styles from "./Footer.module.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
  FaGooglePlay,
  FaLink,
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className={styles.footer} id="footer">
      <div className={styles.footerContent}>
        <div className={styles.footerGrid}>
          {/* Column 1 */}
          <div className={styles.footerColumn}>
            <div className={styles.section}>
              <h3>Connect With Us</h3>
              <div className={styles.socialLinks}>
                <a
                  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fstemxindia.com"
                  target="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fstemxindia.com"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  title="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.linkedin.com/company/stemxindia/?originalSubdomain=in"
                  target="https://www.linkedin.com/company/stemxindia/?originalSubdomain=in"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  title="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href="https://www.instagram.com/stemx_india/?igshid=h17u2z3t2ach"
                  target="https://www.instagram.com/stemx_india/?igshid=h17u2z3t2ach"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  title="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://api.whatsapp.com/send?text=Home%20https%3A%2F%2Fstemxindia.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  title="WhatsApp"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://www.youtube.com/@STEMxIndia/about"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  title="YouTube"
                >
                  <FaYoutube />
                </a>
                <a
                  href="https://linktr.ee/stemx"
                  target="https://linktr.ee/stemx"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  title="Linktree"
                >
                  <FaLink />
                </a>
              </div>
            </div>
            <div className={styles.section}>
              <h3>Product Downloads</h3>
              <ul>
                <li>
                  <a href="/downloads/Crawle_Brochure_v1.STEMx.pdf" download>
                    Download Crawle Brochure
                  </a>
                </li>
                <li>
                  <a href="/downloads/Firepen 3D_Brochure.STEMx .pdf" download>
                    Download Firepen 3D Brochure
                  </a>
                </li>
                <li>
                  <a href="/downloads/Klaw Brochure STEMX .pdf" download>
                    Download Klaw Brochure
                  </a>
                </li>
                <li>
                  <a
                    href="/downloads/PeeCee Compute Kit 1_ Brochure_v1.STEMx .pdf"
                    download
                  >
                    Download PeeCee Compute Kit Brochure
                  </a>
                </li>
                <li>
                  <a href="/downloads/Play Dynamex_Brochure.STEMx.pdf" download>
                    Download Play Dynamex Brochure
                  </a>
                </li>
                <li>
                  <a href="/downloads/Play Tronix_Brochure.STEMx.pdf" download>
                    Download Play Tronix Brochure
                  </a>
                </li>
                <li>
                  <a href="/downloads/Play Trons_Brochure.STEMX .pdf" download>
                    Download Play Trons Brochure
                  </a>
                </li>
                <li>
                  <a href="/downloads/Zing_Brochure_v1 STEMx.pdf" download>
                    Download Zing Brochure
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 2 */}
          <div className={styles.footerColumn}>
            <div className={styles.section}>
              <h3>Contact Details</h3>
              <div className={styles.contactInfo}>
                <p>
                  <FaPhone className={styles.icon} />
                  <a href="tel:+917259981441">+91 72599 81441</a>
                </p>
                <p>
                  <FaPhone className={styles.icon} />
                  <a href="tel:+917816090078">+91 78160 90078</a>
                </p>
                <p>
                  <FaEnvelope className={styles.icon} />
                  <a href="mailto:info@stemxindia.com">info@stemxindia.com</a>
                </p>
                <p>
                  <FaGlobe className={styles.icon} />
                  <a href="https://www.stemxindia.com">www.stemxindia.com</a>
                </p>
              </div>
            </div>
            <div className={styles.section}>
              <h3>Curriculum Downloads</h3>
              <ul>
                <li>
                  <a
                    href="https://drive.google.com/drive/folders/196oDltyWQy-PJGLktLZltV_pY_hxjoUJ"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Curriculum for STEM Robotics and AI Programme
                  </a>
                </li>
                <li>
                  <a href="/downloads/ARVRCurriculum.pdf" download>
                    ARVR Curriculum
                  </a>
                </li>
                <li>
                  <a href="/downloads/PlutoDroneCurriculum.pdf" download>
                    Drone Curriculum
                  </a>
                </li>
                <li>
                  <a
                    href="/downloads/India_Japan_Student_Exchange_Programme.pdf"
                    download
                  >
                    India-Japan Student Exchange Programme Curriculum
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 3 */}
          <div className={styles.footerColumn}>
            <div className={styles.section}>
              <h3>Our Locations</h3>
              <div className={styles.addresses}>
                <div className={styles.address}>
                  <FaMapMarkerAlt className={styles.icon} />
                  <p>
                    <strong>STEMx India - Bangalore</strong>
                    <br />
                    Ground Floor, Om Shakthi Temple Road,
                    <br />
                    Konadasapura, Near to Backgate of
                    <br />
                    Prerana International School,
                    <br />
                    Bangalore – 560049
                  </p>
                </div>
                <div className={styles.address}>
                  <FaMapMarkerAlt className={styles.icon} />
                  <p>
                    <strong>STEMx India - Hyderabad</strong>
                    <br />
                    3-14/1, near Metro Piller No -789,
                    <br />
                    Bagh Ameer, Sumitra Nagar Colony,
                    <br />
                    Kukatpally, Hyderabad,
                    <br />
                    Telangana 500034
                  </p>
                </div>
                <div className={styles.address}>
                  <FaMapMarkerAlt className={styles.icon} />
                  <p>
                    <strong>STEMx India - Andhra Pradesh</strong>
                    <br />
                    Ontillu krishna puram, deguva masapalli,
                    <br />
                    Talambedu cross,
                    <br />
                    Chittoor – 517001
                  </p>
                </div>
                <div className={styles.address}>
                  <FaMapMarkerAlt className={styles.icon} />
                  <p>
                    <strong>STEMx India - Mumbai</strong>
                    <br />
                    Vile Parle,
                    <br />
                    Mumbai – 400029
                  </p>
                </div>
                <div className={styles.address}>
                  <FaMapMarkerAlt className={styles.icon} />
                  <p>
                    <strong>STEMx India - Gurugram</strong>
                    <br />
                    [KTC Holdings-Japan]
                    <br />
                    Ocus Technopolis, Golf Course Road,
                    <br />
                    Sector 54, Gurugram 122002
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.bottomBar}>
        <div className={styles.copyright}>
          © STEM X India 2021. All Rights Reserved. Created by STEMx.
        </div>
        <div className={styles.disclaimer}>
          Disclaimer: Trademarks, logos displayed on this website are the
          registered and unregistered marks of their respective owners
        </div>
      </div>
    </footer>
  );
};

export default Footer;
